<template>
  <div class="pm-list">
    <div class="pm-item" v-for="(item,index) in list" :key="index">
      <router-link class="link pm-item-main" :class="{'flex-block':flex}" :to="{path:'/auction/detail',query:{id:item.id}}">
        <div class="image-box">
          <img class="img" :src="item.rectangle">
        </div>
        <div class="pm-info-box">
          <div class="pm-info">
            <div class="title-row">
              <h3 class="title">{{item.special_name}}</h3>
              <span class="sc-price">(专场 1元/个)</span>
            </div>
            <div class="date">竞拍时间：{{item.start_date + '-' +item.end_date }}</div>
          </div>
          <div>
            <el-button class="btn" round>查看详情</el-button>
          </div>

        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'auctionlist',
  props: {
    //是否是左右布局
    flex: {
      type: Boolean,
      default: false
    },
    //列表数组
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
// 专场列表
.pm-list {
  .pm-item {
    margin-top: 15px;
    box-shadow: 0px 2px 2px 0px rgba(10, 2, 5, 0.14);
    .link{
      color: #333;
      text-decoration: none;
    }
    .title{
      &:hover{
        color: #CFA972
      }
    }
    .pm-item-main {
      display: block;
      position: relative;
      overflow: hidden;
      .image-box {
        .img {
          width: 100%;
        }
      }
      .pm-info-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        box-sizing: border-box;
        width: 100%;
        .pm-info {
          width: 70%;
          .title-row {
            position: relative;
            padding-right: 110px; /* 预留右侧标签空间 */
          }
          .title {
            font-size: 20px;
            line-height: 1.5;
            text-align: center;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            margin-top: 0;
            margin-bottom: 8px;
            text-align: left;
          }
          .sc-price {
            position: absolute;
            right: 0;
            bottom: 8px;
            color: #bc230c;
            font-size: 14px;
            white-space: nowrap;
          }
          .date {
            font-size: 14px;
            color: #999;
          }
        }
      }
    }
    .flex-block {
      display: flex;
      .image-box {
        width: 60%;
        vertical-align: middle;
        .img {
          display: inline-block;
          vertical-align: middle;
        }
      }
      .pm-info-box {
        width: 40%;
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: space-around;
        .pm-info {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          justify-content: flex-end;
          .title-row {
            position: relative;
            padding-right: 110px; /* 预留右侧标签空间 */
          }
          .title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
            line-height: 1.5;
            height: 3em;
            white-space: initial;
            text-align: center;
          }
          .sc-price {
            position: absolute;
            right: 0;
            bottom: 0;
            color: #bc230c;
            font-size: 14px;
            white-space: nowrap;
          }
        }
        .btn {
          max-width: 100%;
        }
      }
    }
  }
}
</style>